import queryString from 'query-string';
import addURLToGlobal from '../../../forkedLib/URL';

addURLToGlobal();

const RESOUCE_ID = {
  /** 首页头部运营位置 */
  homeBannerMarketing: 'homeBannerMarketing',
  fallFromSkyPopup: 'fallFromSkyPopup',
  orderStatusBanner: 'orderStatusBanner',
  nineOneNine: 'nineOneNine',
  /** 账户-我的券列表 */
  myCouponBanner: 'myCouponBanner'
};

function processLink(link: string = '', plusQuery: {[k: string]: string | number;}) {
  try {
    let paramToAdd = plusQuery; // 需要增加的字段
    // sailorc 链接,获取inner_url字段并对其加工
    if (link.startsWith('sailorc') && link.includes('inner_url')) {
      const originInnerUrl = queryString.parseUrl(link, { parseFragmentIdentifier: true }).query.inner_url as string; // parseFragmentIdentifier一定要有,否则会丢失哈希路由
      const newInnerUrl = queryString.stringifyUrl({ url: originInnerUrl, query: plusQuery }, { sort: false }); // 加工inner_url
      paramToAdd = { inner_url: newInnerUrl };
    }
    return queryString.stringifyUrl({ url: link, query: paramToAdd }, { sort: false });
  } catch (error) { // 内部报错时,不能影响正常连接跳转
    console.log(error);
    return link;
  }
}
// const normal = 'https://fooddelivery.mykeeta.test.sankuai.com/web/h5/marketing/lightup#/a?ORIGIN%3D%E4%B8%AD%E6%96%87%26c%3D3%E2%80%88'
// const norma2 = 'https://fooddelivery.mykeeta.test.sankuai.com/web/h5/marketing/lightup?A=fsdf'
// const encodedHash = 'sailorc://keeta.com/browser?a=1&notitlebar=1&inner_url=https%3A%2F%2Ffooddelivery.mykeeta.test.sankuai.com%2Fweb%2Fmarketing%2Fh5%23%2Fpages%2FnewcomerZone%3Ffrom%3Dkeeta_homepage_banner'
// console.log('测试1',  processLink(normal, {a: "AAA"}));
// console.log('测试2',  processLink(norma2, {hashs: "111AAA111"}));
// console.log('测试3',  processLink(encodedHash, {a: "HHHHHHHH"}));

export { RESOUCE_ID, processLink };
